import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { TESTIMONIALS } from '../../lib/site';
import { SectionHeading } from '../ui/SectionHeading';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef<number>();
  const go = (dir: number) => setIndex(i => (i + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  useEffect(() => {
    if (paused) return;
    timer.current = window.setInterval(() => go(1), 5000);
    return () => window.clearInterval(timer.current);
  }, [paused]);
  const t = TESTIMONIALS[index];
  return <section className="relative mx-auto max-w-5xl px-6 py-24" data-id="element-317" data-mp="dywe97qow2o4">
      <SectionHeading eyebrow="Client Stories" title="Trusted by Houston Homeowners" subtitle="Real reviews from families we've helped protect, restore, and rebuild." data-id="element-318" data-mp="2aualfilfvg73" />

      <div className="relative mt-14" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-319" data-mp="1slazpmzbixb8">
        <AnimatePresence mode="wait" data-id="element-320" data-mp="1nrzol9nh3udi">
          <motion.div key={index} initial={{
          opacity: 0,
          y: 30,
          rotateX: -8,
          filter: 'blur(10px)'
        }} animate={{
          opacity: 1,
          y: 0,
          rotateX: 0,
          filter: 'blur(0px)'
        }} exit={{
          opacity: 0,
          y: -30,
          filter: 'blur(10px)'
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} style={{
          perspective: 1000
        }} className="glass-strong relative mx-auto max-w-3xl rounded-[2.5rem] p-10 text-center shadow-glow sm:p-14" data-id="element-321" data-mp="1itya720zsj8d">
            <QuoteIcon className="mx-auto h-10 w-10 text-royal/20" data-id="element-322" data-mp="nlmgft6gwdl4" />
            <div className="mt-4 flex justify-center gap-1" data-id="element-323" data-mp="nmfem5rd1urn">
              {Array.from({
              length: t.rating
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" data-id="element-324" data-mp="elpnhfd1osk9" data-mpi={i} />)}
            </div>
            <p className="mt-6 font-display text-xl font-medium leading-relaxed text-navy sm:text-2xl" data-id="element-325" data-mp="4vekbv16qnef">
              "{t.quote}"
            </p>
            <div className="mt-8" data-id="element-326" data-mp="9mmtqr2im8rl">
              <p className="font-semibold text-navy" data-id="element-327" data-mp="9no7j3ax19d0">{t.name}</p>
              <p className="text-sm text-slate" data-id="element-328" data-mp="3r3xo0hms79u6">{t.location}</p>
              <span className="mt-3 inline-flex items-center gap-2 rounded-full bg-sky px-3 py-1 text-xs font-medium text-royal" data-id="element-329" data-mp="3w0whqz2j9eru">
                <StarIcon className="h-3 w-3 fill-royal" data-id="element-330" data-mp="3i2zghpd4wk6u" /> Google 5-Star Review
              </span>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="mt-8 flex items-center justify-center gap-4" data-id="element-331" data-mp="33efwgabiwgww">
          <button onClick={() => go(-1)} aria-label="Previous review" data-cursor="button" className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-royal shadow-glass transition-colors hover:bg-royal hover:text-white" data-id="element-332" data-mp="33gso5f7325n5">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-333" data-mp="38gez1hzfv9ss" />
          </button>
          <div className="flex gap-2" data-id="element-334" data-mp="3mc8xt86i0is6">
            {TESTIMONIALS.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Go to review ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-8 bg-royal' : 'w-2 bg-royal/25'}`} data-id="element-335" data-mp="3hdxt1bv28ygt" data-mpi={i} />)}
          </div>
          <button onClick={() => go(1)} aria-label="Next review" data-cursor="button" className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-royal shadow-glass transition-colors hover:bg-royal hover:text-white" data-id="element-336" data-mp="8zp6olj4t3x3">
            <ChevronRightIcon className="h-5 w-5" data-id="element-337" data-mp="23duky8q1ehig" />
          </button>
        </div>
      </div>
    </section>;
}